<template>
  <TileCard id="overtime" :loaded="!props.loaded">
    <template #body>
      <span class="title-2">Overtimes overview in hours</span>
      <table>
        <thead></thead>
        <tbody>
          <tr>
            <td class="name">Total project overtime</td>
            <td class=""><span><b>{{ props.overtimeModel.projectTotal }}</b></span></td>
            <td>hours</td>
          </tr>
          <tr>
            <td class=" name">Floating overtime this month</td>
            <td class=""><span><b>{{ props.overtimeModel.floatingThisMonth }}</b></span></td>
            <td>hours</td>
          </tr>
          <tr>
            <td class="name">Project overtime this month</td>
            <td class=""><span> <b>{{ props.overtimeModel.projectThisMonth }}</b></span></td>
            <td>hours</td>
          </tr>
          <tr>
            <td class="name">Project overtime compensation this month</td>
            <td class=""><span> <b>{{ props.overtimeModel.otCompensationHours }}</b></span></td>
            <td>hours</td>
          </tr>
        </tbody>
      </table>
    </template>
  </TileCard>
</template>

<script setup lang="ts">
import { OvertimeModel } from "@/services/entities/OvertimeModel";
import TileCard from "./util/TileCard.vue";

const props = defineProps({
  overtimeModel: { Type: {} as OvertimeModel, default: {} as OvertimeModel },
  loaded: { Type: {} as boolean, default: {} as boolean }
})
</script>

<style scoped lang="scss">
table {
  width: 90%;
  border: none;
  border-collapse: collapse;

  .name {
    width: 75%;
  }

  tbody tr:hover {
    background-color: #00000014; /* Adjust the highlight color as needed */
  }
  }
</style>